import { useEffect, useState } from 'react';
import type { RefObject } from 'react';

import type { XoeContainerSize } from '../../types/xoe/XoeUiTypes';

export const XOE_COMPACT_MAX = 520;
export const XOE_REGULAR_MAX = 900;

const sizeForWidth = (width: number): XoeContainerSize =>
	width < XOE_COMPACT_MAX ? 'compact' : width < XOE_REGULAR_MAX ? 'regular' : 'wide';

// Structural switches only (D6); visual adaptation belongs to xoe.css container queries.
export const useXoeContainerSize = (ref: RefObject<HTMLElement>): XoeContainerSize => {
	const [size, setSize] = useState<XoeContainerSize>('regular');

	useEffect(() => {
		const el = ref.current;
		if (!el || typeof ResizeObserver === 'undefined') return undefined;
		const observer = new ResizeObserver((entries) => {
			const width = entries[entries.length - 1]?.contentRect.width ?? 0;
			// A zero width means no layout (hidden pane, jsdom), not a tiny container.
			if (width > 0) setSize(sizeForWidth(width));
		});
		observer.observe(el);
		return () => observer.disconnect();
	}, [ref]);

	return size;
};
